// 평가지 캡처: html2canvas 없이 canvas에 직접 그려 PNG 생성 → 클립보드 복사. 실패 시 dataUrl 반환해 모달 안에 띄움.
import { EVAL_LISTS, InterviewItem } from './interviewconstants';

const FONT_R = '"Apple_R", "Apple SD Gothic Neo", sans-serif';
const FONT_B = '"Apple_B", "Apple SD Gothic Neo", sans-serif';

export type CaptureResult = { ok: true } | { ok: false, dataUrl: string };

// grades/memo/evaluatorName 은 평가지 모달에서 보고 있는 평가자 탭의 값
export const captureEvaluation = async (item: InterviewItem, category: string, evalGrades: string[], memo: string, evaluatorName: string): Promise<CaptureResult> => {
    // CRM 폰트가 아직 안 불러와졌으면 canvas가 기본 폰트로 그리므로 먼저 로드
    try {
        await Promise.all([(document as any).fonts.load('18px "Apple_R"'), (document as any).fonts.load('18px "Apple_B"')]);
    } catch (e) {
        console.log(e);
    }

    const items = EVAL_LISTS[category];
    const grades = items.map((_, i) => evalGrades[i] || "");
    const W = 960, PAD = 36, LH = 30, NUMW = 44, GRADEW = 200;
    const cv = document.createElement("canvas");
    const ctx = cv.getContext("2d")!;
    ctx.font = "18px " + FONT_R;
    const textW = W - PAD * 2 - NUMW - GRADEW - 24;
    const wrap = (t: string) => {
        const out: string[] = [];
        let cur = "";
        t.split(" ").forEach((w) => {
            const n = cur ? cur + " " + w : w;
            if (ctx.measureText(n).width > textW && cur) { out.push(cur); cur = w; } else { cur = n; }
        });
        if (cur) out.push(cur);
        return out;
    };
    const lines = items.map(wrap);
    const memoLines = memo ? memo.split("\n").flatMap((l, i) => wrap((i === 0 ? "메모 : " : "") + l)) : [];
    const tableH = 48 + lines.reduce((a, l) => a + l.length * LH + 14, 0);
    const H = PAD + tableH + 40 + 36 + 36 + (memoLines.length ? memoLines.length * LH + 8 : 0) + PAD;

    cv.width = W * 2; cv.height = H * 2;
    ctx.scale(2, 2);
    ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, W, H);
    const x0 = PAD, x1 = W - PAD, xg = x1 - GRADEW;
    let y = PAD;

    // 헤더
    ctx.fillStyle = "#f3f3f3"; ctx.fillRect(x0, y, x1 - x0, 48);
    ctx.strokeStyle = "#333333"; ctx.lineWidth = 1;
    ctx.strokeRect(x0, y, x1 - x0, 48);
    ctx.fillStyle = "#111111"; ctx.textBaseline = "middle";
    ctx.font = "19px " + FONT_B; ctx.textAlign = "center";
    ctx.fillText(category + " 평가 리스트", (x0 + xg) / 2, y + 24);
    ctx.fillText("평가 (ABCDE)", (xg + x1) / 2, y + 24);
    y += 48;

    // 항목 행
    lines.forEach((ls, i) => {
        const rh = ls.length * LH + 14;
        ctx.strokeStyle = "#999999"; ctx.setLineDash([3, 3]); ctx.strokeRect(x0, y, x1 - x0, rh); ctx.setLineDash([]);
        ctx.beginPath(); ctx.moveTo(x0 + NUMW, y); ctx.lineTo(x0 + NUMW, y + rh); ctx.moveTo(xg, y); ctx.lineTo(xg, y + rh); ctx.strokeStyle = "#999999"; ctx.stroke();
        ctx.fillStyle = "#111111"; ctx.font = "18px " + FONT_B; ctx.textAlign = "center";
        ctx.fillText(String(i + 1), x0 + NUMW / 2, y + rh / 2);
        ctx.font = "18px " + FONT_R; ctx.textAlign = "left";
        ls.forEach((l, li) => { ctx.fillText(l, x0 + NUMW + 12, y + 7 + LH * li + LH / 2); });
        ctx.font = "20px " + FONT_B; ctx.textAlign = "center";
        ctx.fillText(grades[i] || "-", (xg + x1) / 2, y + rh / 2);
        y += rh;
    });

    // 면접자 / 평가 담당자 / 메모
    y += 40;
    ctx.fillStyle = "#111111"; ctx.textAlign = "left"; ctx.font = "19px " + FONT_B;
    ctx.fillText("면접자 : " + item.name + " (" + item.location + " " + item.job + ")", x0, y); y += 36;
    ctx.fillText("평가 담당자 : " + evaluatorName, x0, y); y += 36;
    ctx.font = "17px " + FONT_R; ctx.fillStyle = "#333333";
    memoLines.forEach((l) => { ctx.fillText(l, x0, y); y += LH; });

    const dataUrl = cv.toDataURL("image/png");
    try {
        const blob: Blob | null = await new Promise((resolve) => cv.toBlob(resolve, "image/png"));
        const ClipboardItemCtor = (window as any).ClipboardItem;
        if (!blob || !ClipboardItemCtor || !navigator.clipboard || !(navigator.clipboard as any).write) return { ok: false, dataUrl };
        await (navigator.clipboard as any).write([new ClipboardItemCtor({ "image/png": blob })]);
        return { ok: true };
    } catch (e) {
        console.log(e);
        return { ok: false, dataUrl };
    }
};
